// extracted by mini-css-extract-plugin
export default {"MainHeader":"header_MainHeader__PqfR1","navigations":"header_navigations__vO6h4","SearchbarSide":"header_SearchbarSide__ZFaCb"};